// extracted by mini-css-extract-plugin
export var chatHtmlText = "_mf-2";
export var chatLink = "_mf-0";
export var chatText = "_mf-1";